import BaseRestService from "./BaseRestService";

class ContentPropertyService extends BaseRestService {
  async getContentProperty(propertyKey) {
    const url = `/api/contentproperty?propertyKey=${propertyKey}`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async createContentProperty(propertyKey, value) {
    const url = "/api/contentproperty/create";
    return this.client.post(
      url,
      { data: { propertyKey, value } },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async updateContentProperty(propertyKey, value, versionNumber) {
    const url = "/api/contentproperty/update";
    return this.client.put(
      url,
      { data: { propertyKey, value, versionNumber } },
      await this.buildJWTAuthAxiosConfig()
    );
  }
}

export const contentPropertyService = new ContentPropertyService();
